// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * cdr-shared-api
 * Shared API Gateway for all CDR endpoints
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { GetStatistics200ResponseVendors } from './get-statistics200-response-vendors';
import {
    GetStatistics200ResponseVendorsFromJSON,
    GetStatistics200ResponseVendorsFromJSONTyped,
    GetStatistics200ResponseVendorsToJSON,
    GetStatistics200ResponseVendorsToJSONTyped,
} from './get-statistics200-response-vendors';
import type { GetStatistics200ResponseDtas } from './get-statistics200-response-dtas';
import {
    GetStatistics200ResponseDtasFromJSON,
    GetStatistics200ResponseDtasFromJSONTyped,
    GetStatistics200ResponseDtasToJSON,
    GetStatistics200ResponseDtasToJSONTyped,
} from './get-statistics200-response-dtas';
import type { GetStatistics200ResponseStudies } from './get-statistics200-response-studies';
import {
    GetStatistics200ResponseStudiesFromJSON,
    GetStatistics200ResponseStudiesFromJSONTyped,
    GetStatistics200ResponseStudiesToJSON,
    GetStatistics200ResponseStudiesToJSONTyped,
} from './get-statistics200-response-studies';

/**
 * 
 * @export
 * @interface GetStatistics200Response
 */
export interface GetStatistics200Response {
    /**
     * 
     * @type {GetStatistics200ResponseDtas}
     * @memberof GetStatistics200Response
     */
    dtas: GetStatistics200ResponseDtas;
    /**
     * 
     * @type {GetStatistics200ResponseStudies}
     * @memberof GetStatistics200Response
     */
    studies: GetStatistics200ResponseStudies;
    /**
     * 
     * @type {GetStatistics200ResponseVendors}
     * @memberof GetStatistics200Response
     */
    vendors: GetStatistics200ResponseVendors;
}

/**
 * Check if a given object implements the GetStatistics200Response interface.
 */
export function instanceOfGetStatistics200Response(value: object): value is GetStatistics200Response {
    if (!('dtas' in value) || value['dtas'] === undefined) return false;
    if (!('studies' in value) || value['studies'] === undefined) return false;
    if (!('vendors' in value) || value['vendors'] === undefined) return false;
    return true;
}

export function GetStatistics200ResponseFromJSON(json: any): GetStatistics200Response {
    return GetStatistics200ResponseFromJSONTyped(json, false);
}

export function GetStatistics200ResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetStatistics200Response {
    if (json == null) {
        return json;
    }
    return {
        
        'dtas': GetStatistics200ResponseDtasFromJSON(json['dtas']),
        'studies': GetStatistics200ResponseStudiesFromJSON(json['studies']),
        'vendors': GetStatistics200ResponseVendorsFromJSON(json['vendors']),
    };
}

export function GetStatistics200ResponseToJSON(json: any): GetStatistics200Response {
    return GetStatistics200ResponseToJSONTyped(json, false);
}

export function GetStatistics200ResponseToJSONTyped(value?: GetStatistics200Response | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'dtas': GetStatistics200ResponseDtasToJSON(value['dtas']),
        'studies': GetStatistics200ResponseStudiesToJSON(value['studies']),
        'vendors': GetStatistics200ResponseVendorsToJSON(value['vendors']),
    };
}
